import React from 'react';
import { connect } from 'dva';
import style from './index.less';

@connect(({ contactsList }) => ({
  searchResult: contactsList.searchResult,
}))

class SearchMsg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  informationBlock(searchResult) {
    if (searchResult.length === 0) {
      return <div className="unSearchMsg">未搜到相关人员</div>;
    }
    const msg = searchResult.map(items => {
      if (items && items.userDetailList.length > 0) {
        return this.personBlock(items);
      }
    });
    const haveMsg = (msg || []).some(items => {
      return items !== undefined;
    });
    if (!haveMsg) {
      return <div className="unSearchMsg">未搜到相关人员</div>;
    }
    return msg;
  }

  personBlock(items) {
    return (
      <div className="everBlock">
        <div className="nodeName">{items.userTypeName}</div>
        <div className="nodeBox">
          {(items.userDetailList || []).map(item => {
            const params = {
              roleSign: items.roleSign,
              userId: item.userId,
              userName: item.userName,
            };
            return (
              <div className="searchPerson" onClick={this.showPersonMsg.bind(this, params)}>
                {item.userName}
                <span style={{ color: '#999' }}>{item.userTag ? ` (${item.userTag})` : ''}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // 显示个人详细信息
  showPersonMsg(params) {
    const { dispatch } = this.props;
    dispatch({
      type: 'contactsList/save',
      payload: {
        showUserDetailsLayer: true,
      },
    });
    dispatch({
      type: 'contactsList/fetchUserDetails',
      userId: params.userId,
    });

  }

  render() {
    const { searchResult } = this.props;
    if (searchResult === null) {
      return null;
    }

    return <div className={style.SearchMsg}>{this.informationBlock(searchResult)}</div>;
  }
}

export default SearchMsg;
